__turbopack_context__.v({
  "ArtistCarousel": "miWY-G_ArtistCarousel",
  "ArtistCarousel__Button--Disabled": "miWY-G_ArtistCarousel__Button--Disabled",
  "ArtistCarousel__Button--Next": "miWY-G_ArtistCarousel__Button--Next",
  "ArtistCarousel__Button--Prev": "miWY-G_ArtistCarousel__Button--Prev",
  "ArtistCarousel__ButtonWrapper": "miWY-G_ArtistCarousel__ButtonWrapper",
  "ArtistCarousel__Card": "miWY-G_ArtistCarousel__Card",
  "ArtistCarousel__CardImage": "miWY-G_ArtistCarousel__CardImage",
  "ArtistCarousel__CardText": "miWY-G_ArtistCarousel__CardText",
  "ArtistCarousel__CardTitle": "miWY-G_ArtistCarousel__CardTitle",
  "ArtistCarousel__CardWrapper": "miWY-G_ArtistCarousel__CardWrapper",
  "ArtistCarousel__Container": "miWY-G_ArtistCarousel__Container",
  "ArtistCarousel__SwiperButtons": "miWY-G_ArtistCarousel__SwiperButtons",
  "ArtistCarousel__Tag": "miWY-G_ArtistCarousel__Tag",
  "ArtistCarousel__TagList": "miWY-G_ArtistCarousel__TagList",
  "ArtistCarousel__TextWrapper": "miWY-G_ArtistCarousel__TextWrapper",
  "ArtistCarousel__Title": "miWY-G_ArtistCarousel__Title",
});
